import React from 'react';
import PropTypes from 'prop-types';
import { MapContainer, ImageOverlay, Popup, Marker } from 'react-leaflet';
import L, { CRS } from 'leaflet';
import MarkerClusterGroup from '../MarkerClusterGroup';

import markerRed from '../../../../../../../assets/images/marker-red.svg';
import markerBlue from '../../../../../../../assets/images/marker-blue.svg';
import markerGreen from '../../../../../../../assets/images/marker-green.svg';
import markerYellow from '../../../../../../../assets/images/marker-yellow.svg';
import markerPurple from '../../../../../../../assets/images/marker-purple.svg';

function ImageReportMap(props) {
  const { coordinates, imageUrl, center, bounds, maxBounds, onMapReady, onMapFit, inputs } = props;

  const inputsKeyedById =
    inputs?.reduce((acc, input) => {
      acc[input.id] = input;
      return acc;
    }, {}) || {};

  const whenReady = ({ target: map }) => {
    onMapReady?.(map);
    setTimeout(() => {
      map.fitBounds(bounds, { animate: false });
      map.setMinZoom(map.getZoom());
      setTimeout(() => {
        onMapFit?.(map);
      }, 0);
    }, 0);
  };

  const pinConfig = {
    className: 'svg-pin',
    iconSize: [40, 40],
    iconAnchor: [20, 40],
    popupAnchor: [0, 0],
  };

  const pins = {
    red: L.icon({
      iconUrl: markerRed,
      ...pinConfig,
    }),
    blue: L.icon({
      iconUrl: markerBlue,
      ...pinConfig,
    }),
    green: L.icon({
      iconUrl: markerGreen,
      ...pinConfig,
    }),
    yellow: L.icon({
      iconUrl: markerYellow,
      ...pinConfig,
    }),
    purple: L.icon({
      iconUrl: markerPurple,
      ...pinConfig,
    }),
  };

  const getPin = (inputId) => {
    if (!inputsKeyedById || !inputsKeyedById[inputId]) return pins.red;

    const color = inputsKeyedById[inputId].metadata?.color;

    return pins[color];
  };

  return (
    <MapContainer
      className="image-report-map"
      center={center}
      maxBounds={maxBounds}
      zoom={0}
      minZoom={-2}
      maxZoom={4}
      crs={CRS.Simple}
      zoomSnap={0}
      zoomDelta={0.5}
      whenReady={whenReady} // incorrect typing
    >
      <ImageOverlay url={imageUrl} bounds={bounds} />
      <MarkerClusterGroup>
        {coordinates.map((entry) => (
          <Marker
            key={`${entry}-${entry.x}-${entry.y}`}
            position={[entry.y, entry.x]}
            icon={getPin(entry.inputId)}
          >
            {entry.comment && <Popup>{entry.comment}</Popup>}
          </Marker>
        ))}
      </MarkerClusterGroup>
    </MapContainer>
  );
}

ImageReportMap.propTypes = {
  coordinates: PropTypes.arrayOf(
    PropTypes.shape({
      x: PropTypes.number.isRequired,
      y: PropTypes.number.isRequired,
      comment: PropTypes.string,
    })
  ).isRequired,
  imageUrl: PropTypes.string.isRequired,
  center: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  bounds: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number.isRequired).isRequired).isRequired,
  maxBounds: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number.isRequired).isRequired)
    .isRequired,
  onMapReady: PropTypes.func,
  onMapFit: PropTypes.func,
  inputs: PropTypes.arrayOf(PropTypes.shape({})),
};

ImageReportMap.defaultProps = {
  onMapReady: undefined,
  onMapFit: undefined,
  inputs: undefined,
};

export default ImageReportMap;
